import { Component } from '@angular/core';

@Component({
  selector: 'hrConfig',
  templateUrl: './hrConfig.component.html',
  styleUrls: ['../hr.component.css'],
})

export class HrConfigComponent {

  constructor() {
  }

  headerText: string = 'HR Config';

  //Tables
  showClearanceStatusTable: boolean = false;
  showDepartmentsTable: boolean = false;
  showEeoTypeTable: boolean = false;
  showEmpJobAssignmentsTable: boolean = false;
  showEmpStatusTable: boolean = false;
  showEmploymentStatusTable: boolean = false;
  showEmploymentTypeTable: boolean = false;
  showGenderTypeTable: boolean = false;
  showFyPayRatesTable: boolean = false;
  showJobCategoriesTable: boolean = false;
  showJobTitlesTable: boolean = false;
  showMaritalStatusTable: boolean = false;
  showOccStatusTable: boolean = false;
  showOtherSpecialtyTypeTable: boolean = false;
  showPscTypeTable: boolean = false;
  showShareholderTypeTable: boolean = false;
  showUnionAffiliationTable: boolean = false;
  showWorkSectionsTable: boolean = false;

  tableDropDownItems: Array<any> = [
    {
      'name': 'Clearance Status'
    }, {
      'name': 'Departments'
    }, {
      'name': 'EEO Type'
    }, {
      'name': 'Employee Job Assignments'
    }, {
      'name': 'Employee Status'
    }, {
      'name': 'Employment Status'
    }, {
      'name': 'Employment Type'
    }, {
      'name': 'Fiscal Pay Rates'
    }, {
      'name': 'Gender Type'
    }, {
      'name': 'Job Categories'
    }, {
      'name': 'Job Titles'
    }, {
      'name': 'Marital Status'
    }, {
      'name': 'OCC Status'
    }, {
      'name': 'Other Specialty Type'
    }, {
      'name': 'PSC Type'
    }, {
      'name': 'Shareholder Type'
    }, {
      'name': 'Union Affiliation'
    }, {
      'name': 'Work Sections'
    }
  ];

  //***************************
  // Functions 
  //***************************

  getSelectedTable(event: any): void {
    this.headerText = 'HR Config-' + event.value;
    this.closeAllTables();

    switch (event.value) {
      case 'Clearance Status': {
        this.showClearanceStatusTable = true;
        break;
      }
      case 'Departments': {
        this.showDepartmentsTable = true;
        break;
      }
      case 'EEO Type': {
        this.showEeoTypeTable = true;
        break;
      }
      case 'Employee Job Assignments': {
        this.showEmpJobAssignmentsTable = true;
        break;
      }
      case 'Employee Status': {
        this.showEmpStatusTable = true;
        break;
      }
      case 'Employment Status': {
        this.showEmploymentStatusTable = true;
        break;
      }
      case 'Employment Type': {
        this.showEmploymentTypeTable = true;
        break;
      }
      case 'Gender Type': {
        this.showGenderTypeTable = true;
        break;
      }
      case 'Fiscal Pay Rates': {
        this.showFyPayRatesTable = true;
        break;
      }
      case 'Job Categories': {
        this.showJobCategoriesTable = true;
        break;
      }
      case 'Job Titles': {
        this.showJobTitlesTable = true;
        break;
      }
      case 'Marital Status': {
        this.showMaritalStatusTable = true;
        break;
      }
      case 'OCC Status': {
        this.showOccStatusTable = true;
        break;
      }
      case 'Other Specialty Type': {
        this.showOtherSpecialtyTypeTable = true;
        break;
      }
      case 'PSC Type': {
        this.showPscTypeTable = true;
        break;
      }
      case 'Shareholder Type': {
        this.showShareholderTypeTable = true;
        break;
      }
      case 'Union Affiliation': {
        this.showUnionAffiliationTable = true;
        break;
      }
      case 'Work Sections': {
        this.showWorkSectionsTable = true;
        break;
      }
    }
  }

  public closeAllTables() {

    this.showClearanceStatusTable = false;
    this.showDepartmentsTable = false;
    this.showEeoTypeTable = false;
    this.showEmpJobAssignmentsTable = false;
    this.showEmpStatusTable = false;
    this.showEmploymentTypeTable = false;
    this.showGenderTypeTable = false;
    this.showFyPayRatesTable = false;
    this.showJobCategoriesTable = false;
    this.showJobTitlesTable = false;
    this.showMaritalStatusTable = false;
    this.showOccStatusTable = false;
    this.showOtherSpecialtyTypeTable = false;
    this.showPscTypeTable = false;
    this.showShareholderTypeTable = false;
    this.showEmploymentStatusTable = false;
    this.showUnionAffiliationTable = false;
    this.showWorkSectionsTable = false;
  }

  ngOnInit(): void {
  };

  ngOnDestroy() {
  }

}
